<template>
  <v-main>
    <v-container>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card class="mx-auto">
            <v-card-text>
              <div class="text-h5 text--primary ">
                Release Note
              </div>
              <div class="text-body-1 text--secondary">
                currently version : 1.1.0
              </div>
              <template>
                <div v-for="(item, index) in List" :key="'release' + index">
                  <v-divider class="my-2"></v-divider>
                  <div class="text-h5 text--primary py-2">
                    Version {{ item.version }} ( {{ item.date }} )
                  </div>
                  <template v-for="(itemC, indexC) in item.changelist">
                    <div :key="`changelist${index}-${indexC}`">
                      <div class="text-h6 text--primary">{{ itemC.title }}</div>
                      <ul class="py-1">
                        <li
                          v-for="(subtitle, indexS) in itemC.subtitle"
                          :key="`subtitle${index}-${indexC}-${indexS}`"
                          class="text-body-1 text--secondary"
                        >
                          {{ subtitle }}
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </template>
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn text color="teal accent-4" @click="reveal = true">
                Learn More
              </v-btn>
            </v-card-actions> -->

            <!-- <v-expand-transition>
              <v-card
                v-if="reveal"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
                <v-card-text class="pb-0">
                  <p class="text-h4 text--primary">
                    Origin
                  </p>
                  <p>
                    late 16th century (as a noun denoting a place where alms
                    were distributed): from medieval Latin eleemosynarius, from
                    late Latin eleemosyna ‘alms’, from Greek eleēmosunē
                    ‘compassion’
                  </p>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn text color="teal accent-4" @click="reveal = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      reveal: false,
      List: [
        {
          version: "1.1.0",
          date: "17 ตุลาคม 2565",
          changelist: [
            {
              title: "ปรับแก้การแสดงผลแบบฟอร์มการลา",
              subtitle: [
                "ค้นหารายชื่อผู้ปฏิบัติงานแทน/ผู้อนุมัติ ในฟอร์มลาแบบ Auto",
                "เพิ่มส่วนของการสรุปการลา ในแบบฟอร์มการลาพักผ่อน , ลาป่วย , ลากิจ , ลาคลอดบุตร",
              ],
            },
            {
              title: "ระบบจัดการสิทธิ์",
              subtitle: [
                "การจัดการสิทธิ์ รองรับกรณีที่ได้รับสิทธิ์เดียวกัน สามารถกำหนดให้ดูได้หลายหน่วยงาน",
              ],
            },
            {
              title: "เพิ่ม Release Note",
              subtitle: [],
            },
          ],
        },
        {
          version: "1.0.0",
          date: "29 กันยายน 2565",
          changelist: [
            {
              title: "ระบบลาออนไลน์",
              subtitle: [
                "ปรับแก้เกณฑ์การคำนวณวันลาพักผ่อนสะสม ของพนักงานมหาวิทยาลัย ตามประกาศมหาวิทยาลัยเชียงใหม่ เรื่อง วันเวลาปฏิบัติงาน วันหยุด ประเภทการลา หลักเกณฑ์วิธีการ เงื่อนไขการลา และการได้รับเงินเดือนระหว่างลาของพนักงานมหาวิทยาลัย (ฉบับที่ 4) พ.ศ. 2565",
              ],
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.loading = true;
  },

  methods: {
    onLoadDone() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
